import { get } from 'lodash';
import flowRight from 'lodash/flowRight';
import { connect } from 'react-redux';
import { withCustomMetrics } from '@zocdoc-frontend-common/utils-frontend-metrics';
import {
    shouldShowMFAInAuthSelector,
    shouldShowTranslatorSelector,
} from 'src/config/ab/selector';
import { showLoginModal, closeLoginModal } from '../../actions/SignUpActions';
import {
    BOOKING_CONTAINER_ROOT_KEY,
    INITIAL_BOOKING_ROOT_KEY,
} from '../../constants';
import { logEvent } from '../../utils';
import { didYouStepAwayModalContent } from '../ModalContent';
import * as Actions from './BookingContainerActions';
import { BookingContainerView } from './BookingContainerView';

export const PageExitEvents = {
    startsignin: 'ExitSignIn',
    createaccount: 'ExitCreateAccount',
    start: 'ExitStart',
    patient: 'ExitPatientSelect',
    verify: 'ExitPhone',
    review: 'ExitReview',
    sync: 'ExitSync',
    complete: 'ExitComplete',
};

export const mapStateToProps = (state = {}, ownProps) => {
    if (state[BOOKING_CONTAINER_ROOT_KEY] === undefined) {
        throw new Error(
            `Expected the ${state[BOOKING_CONTAINER_ROOT_KEY]} state to be available as ` +
                `state.${state[BOOKING_CONTAINER_ROOT_KEY]}. ` +
                "Ensure you have added the 'bookingContainerReducer' to your store's " +
                "reducers via 'combineReducers'."
        );
    }

    if (state[INITIAL_BOOKING_ROOT_KEY] === undefined) {
        throw new Error(
            `Expected the ${state[INITIAL_BOOKING_ROOT_KEY]} state to be available as ` +
                `state.${state[INITIAL_BOOKING_ROOT_KEY]}. Something went wrong with setting up the initial state...`
        );
    }

    const pathTokens = get(
        state.routing,
        'locationBeforeTransitions.pathname',
        ''
    ).split('/');
    const currentPage = pathTokens.length >= 3 ? pathTokens[2] : null;
    const queryTokens = get(
        state.routing,
        'locationBeforeTransitions.query',
        {}
    );
    const queryError = queryTokens.error;

    const bookingPage = state[INITIAL_BOOKING_ROOT_KEY];

    const loggedInUser = bookingPage.loggedInUser;

    return {
        showSecureHeader: get(
            state[BOOKING_CONTAINER_ROOT_KEY],
            'showSecureHeader',
            true
        ),
        currentPage,
        queryError,
        ...state[BOOKING_CONTAINER_ROOT_KEY],
        ...state[INITIAL_BOOKING_ROOT_KEY],
        loggedInUser,
        shouldShowTranslator: shouldShowTranslatorSelector(state),
        shouldShowMFAInAuthSelector: shouldShowMFAInAuthSelector(state),
    };
};

export const mapDispatchToProps = (dispatch, ownProps) => ({
    exitPage: (page) => {
        logEvent({
            event: { name: PageExitEvents[page] },
            bookingId: ownProps.params.bookingId,
        });
    },
    showYouSteppedAwayModal: () => {
        const dispatchHideModal = () => dispatch(Actions.hideModal());
        dispatch(
            Actions.showModal(
                didYouStepAwayModalContent({
                    handlePrimaryButtonClick: dispatchHideModal,
                })
            )
        );
    },
    onClickLoginLink: () => dispatch(showLoginModal()),
    onCloseLoginModal: () => dispatch(closeLoginModal()),
});

export default flowRight(
    connect(mapStateToProps, mapDispatchToProps),
    withCustomMetrics({
        page: 'Booking',
    })
)(BookingContainerView);
